import React from "react"
import { FormattedNumber, injectIntl } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import InfoIconTooltip from "../tooltip/tooltips/InfoIconTooltip"
import "./styles/styles.scss"

type OwnProps = {
    title: string,
    currency: string,
    amount: string,
    notes?: string,
    displayTooltip?: boolean
    tooltipMessage?: string
    
}

const BaseStatBox = (props: OwnProps & IntlProps) => {

    return (
        <div className="stat-box-card">
            <div className="stat-box-header">
                <div className="work-sans-font h5 mb-0">{props.title}</div>
                { props.displayTooltip && <InfoIconTooltip tooltipMessage={props.tooltipMessage} />}
            </div>
            <div className="payout-statbox-amount">
                <FormattedNumber
                    style="currency"
                    currency={props.currency}
                    value={props.amount || "0.00"}
                />
            </div>
            <div className="payout-statbox-notes">{props.notes}</div>
        </div>
    )
}

export default injectIntl(BaseStatBox)


// WEBPACK FOOTER //
// ./src/common/statbox/BaseStatBox.tsx